export default {
    primaryColor: "#F95B48",
    secondaryColor: "F8A84C",
    tertiaryColor: "F3E081",
    danger: "orange",
    black: "black",
    white: "white",
    breakpoints: {
        mobile: "(max-width: 550px)",
        tablet: "(max-width: 800px)",
    },

}